import PropertyPath from './PropertyPath';

export default PropertyPath;
